import { Link } from 'gatsby';
import { Label } from '@primer/react';
import { HeadingTags, HeadingSizes } from '@primer/react-brand';
import { PropTableValues } from "../../../../src/components";
import ComponentLayout from "../../../../src/layouts/component-layout";
import * as React from 'react';
export default {
  Link,
  Label,
  HeadingTags,
  HeadingSizes,
  PropTableValues,
  ComponentLayout,
  React
};